import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';

@Component({
    selector: 'app-button',
    template: `
    <div class="row">
      <div class="col-md-12">
        <div class="text-end" [formGroup]="group">
          <button [disabled] = "group.invalid || false" color="primary" mat-raised-button type="submit">
            {{field.label | translate}}
          </button>
        </div>
      </div>
    </div>
`,
    styles: [],
    standalone: false
})
export class ButtonComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() { }
  ngOnInit() {
  }

}
